import { Combobox } from '@base-ui/react/combobox'
import styled, { css } from 'styled-components'
import { triggerStyles } from 'sutra/components/Select/select-styles'
import type { SelectSize } from 'sutra/components/Select/select-styles'
import { accents, brand, gray } from 'sutra/tokens/colors'

const shellSizeStyles = {
  sm: css`
    min-height: 30px;
    padding: 2px 8px;
    font-size: 13px;
  `,
  md: css`
    min-height: 40px;
    padding: 4px 10px 4px 8px;
    font-size: 14px;
  `,
}

// The Select trigger's look (border, hover, open border), grown into a field
// that wraps: the chips and the inline search input live inside it, so the
// height is a minimum rather than fixed.
export const Shell = styled(Combobox.Chips)<{ $size: SelectSize }>`
  ${triggerStyles}
  height: auto;
  cursor: text;
  ${({ $size }) => shellSizeStyles[$size]}

  &:focus-within {
    border-color: ${brand.stillNight[800]};
  }
  &[data-invalid],
  &[data-invalid]:focus-within {
    border-color: ${accents.crimsonBloom[500]};
  }
  &[data-disabled] {
    opacity: 0.5;
    cursor: not-allowed;
    background: ${brand.white};
  }
`

export const ChipArea = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  min-width: 0;
`

// Base UI's Chip is a plain div that carries the roving focus and the
// Backspace/Delete removal; the look is the Sutra Chiclet rendered inside it.
export const ChipHost = styled(Combobox.Chip)`
  display: inline-flex;
  max-width: 100%;
  border-radius: 4px;
  outline: none;

  &:focus-visible {
    outline: 2px solid ${accents.reflectionBlue[500]};
    outline-offset: 1px;
  }
`

export const SearchField = styled(Combobox.Input)`
  flex: 1;
  min-width: 60px;
  height: 24px;
  padding: 0;
  font-family: inherit;
  font-size: inherit;
  color: ${brand.stillNight[800]};
  background: transparent;
  border: none;
  outline: none;

  &::placeholder {
    color: #a4a7ae;
  }
  &:disabled {
    cursor: not-allowed;
  }
`

export const ClearButton = styled(Combobox.Clear)`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  padding: 2px;
  color: ${gray[500]};
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    color: ${brand.stillNight[800]};
  }
  &:focus-visible {
    outline: 2px solid ${accents.reflectionBlue[500]};
  }
`

export const GroupLabel = styled(Combobox.GroupLabel)`
  padding: 8px 10px 4px;
  font-size: 11px;
  font-weight: 600;
  color: ${gray[500]};
`
